import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si mi pareja no quiere leerlo?',
    a: 'Sí, el manual está centrado en TU claridad. Si tú cambias de posición, la dinámica cambia.'
  }, {
    q: '¿Es un libro físico?',
    a: 'No, es un acceso digital inmediato en PDF para que puedas leerlo en privado ahora mismo.'
  }, {
    q: '¿Qué pasa si decido quedarme?',
    a: 'El libro te da las bases para una «Relación 2.0» mucho más honesta que la anterior.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#141414]" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-3xl sm:text-4xl font-serif text-brand-offwhite mb-12 text-center" data-id="element-20">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-22">
              <div className="border border-white/10 rounded-lg overflow-hidden bg-[#1a1a1a]" data-id="element-23">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-24">
                  <span className="font-medium text-brand-offwhite text-lg" data-id="element-25">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-amber transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-26" />
                </button>
                <AnimatePresence data-id="element-27">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-28">
                      <div className="px-6 pb-6 text-brand-offwhite/70 leading-relaxed" data-id="element-29">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}